import axios from 'axios';
import { IFirmaInfo } from '@/shared/model/firm_info.model';

const baseApiUrl = 'api/firmaInfo';

export default class FirmaInfoService {
  public update(entity: IFirmaInfo): Promise<IFirmaInfo> {
    return new Promise<IFirmaInfo>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public get(): Promise<IFirmaInfo> {
    return new Promise<IFirmaInfo>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
